import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import {
  MyJourneyScreen,
  WeeklyGoalsScreen,
  ActivityDetailScreen,
  ProgressTrackerScreen,
  CreateJourneyScreen,
} from '../screens/journey';
import { ResponsiveHeader } from '../components/layout';
import {
  getRouteTitle,
  shouldShowBackButton,
} from '../config/navigationConfig';

const Stack = createNativeStackNavigator();

export function JourneyNavigator() {
  return (
    <Stack.Navigator
      initialRouteName='index'
      screenOptions={{
        headerShown: true,
        header: (props: any) => <ResponsiveHeader {...props} />,
      }}
    >
      {/* Main journey screen at root level - URL will be /journey */}
      <Stack.Screen
        name='index'
        component={MyJourneyScreen}
        options={{
          title: getRouteTitle('journey'),
          header: (props: any) => (
            <ResponsiveHeader {...props} forceShowBack={false} />
          ),
        }}
      />
      <Stack.Screen
        name='createJourney'
        component={CreateJourneyScreen}
        options={{
          title: 'Create Journey',
          header: (props: any) => (
            <ResponsiveHeader
              {...props}
              forceShowBack={shouldShowBackButton('createJourney')}
            />
          ),
        }}
      />
      <Stack.Screen
        name='weeklyGoals'
        component={WeeklyGoalsScreen}
        options={{
          title: 'Weekly Goals',
          header: (props: any) => (
            <ResponsiveHeader
              {...props}
              forceShowBack={shouldShowBackButton('weeklyGoals')}
            />
          ),
        }}
      />
      <Stack.Screen
        name='activityDetail'
        component={ActivityDetailScreen}
        options={{
          title: 'Activity Detail',
          header: (props: any) => (
            <ResponsiveHeader
              {...props}
              forceShowBack={shouldShowBackButton('activityDetail')}
            />
          ),
        }}
      />
      <Stack.Screen
        name='progressTracker'
        component={ProgressTrackerScreen}
        options={{
          title: 'Progress Tracker',
          header: (props: any) => (
            <ResponsiveHeader
              {...props}
              forceShowBack={shouldShowBackButton('progressTracker')}
            />
          ),
        }}
      />
    </Stack.Navigator>
  );
}
